export function getBoundaries(bboxArray) {
  let x1Arr = bboxArray.map((c) => c[0]);
  let y1Arr = bboxArray.map((c) => c[1]);
  let x2Arr = bboxArray.map((c) => c[2]);
  let y2Arr = bboxArray.map((c) => c[3]);

  let x1 = Math.min(...x1Arr);
  let y1 = Math.min(...y1Arr);
  let x2 = Math.max(...x2Arr);
  let y2 = Math.max(...y2Arr);

  let totalBounds = [x1, y1, x2, y2];
  return totalBounds;
}
